import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { Col, Container, CustomInput, Label, Row } from 'reactstrap';
import { uniqueId } from 'lodash';

const PayerRadioButton2 = ({ title, selected = false, setSelected, disabled = false }) => {
  const [id] = useState(() => uniqueId('PayerRadioButton-'));

  return (
    <Label>
      <Container>
        <Row>
          <Col className="px-0">
            <CustomInput
              id={id}
              type="radio"
              checked={selected}
              onChange={event => setSelected(event.target.checked)}
              disabled={disabled}
            />
          </Col>
          <Col className="px-0">{title}</Col>
        </Row>
      </Container>
    </Label>
  );
};

PayerRadioButton2.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.bool,
  setSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export { PayerRadioButton2 };
